import {combineReducers} from "redux";
import {reducer as toastrReducer} from 'react-redux-toastr';

import * as auth from "../app/Modules/Auth/_redux/authRedux";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  toastr: toastrReducer
});
